import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 9 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 5\" id=\"down\"><path fill-rule=\"evenodd\" d=\"M4.5 4.09L0-.001h9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol